// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:06:05

export default {
  "id": "extreme-real-car-driving-2025",
  "slug": "extreme-real-car-driving-2025",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/79c7a49fba6441a8899c011b1ea8b6e0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/79c7a49fba6441a8899c011b1ea8b6e0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Extreme Real Car Driving 2025",
      "description": "This ultimate car racing 3D lets you experience real car driving simulator like highway racing with its realistic car damage, accurate car driving physics and many other features. Car driver may use steering wheel, accelerator meter or buttons to control the car. Enjoy the best car driving simulator game and drag racing game that has an addictive game play with endless fun. Now you can modify your any sports race cars from garage according to your interest.",
      "instructions": "Use \"W,A,S,D\" for player movement.",
      "genres": [
        "Racing & Driving",
        "Simulation"
      ],
      "tags": [
        "city",
        "desert",
        "drift",
        "stunts",
        "track"
      ]
    },
    "zh-CN": {
      "title": "极限真实汽车驾驶2025",
      "description": "这款终极3D赛车游戏让您体验真实的赛车模拟，如高速公路竞速，具备逼真的车辆损坏、精确的驾驶物理效果以及许多其他特色。赛车手可以使用方向盘、油门表或按钮来控制赛车。享受这款最佳赛车模拟游戏和拉力赛游戏，其引人入胜的游戏玩法和无限乐趣。现在您可以根据兴趣在车库中修改任何运动赛车。",
      "instructions": "使用“W,A,S,D”进行玩家移动。",
      "genres": [
        "赛车与驾驶",
        "模拟"
      ],
      "tags": [
        "城市",
        "沙漠",
        "漂移",
        "特技",
        "赛道"
      ]
    },
    "zh-TW": {
      "title": "極端真實車輛駕駛2025",
      "description": "這款最終版的3D賽車遊戲讓您體驗真實的車輛駕駛模擬器，如高速公路賽車，具有逼真的車輛損壞、精準的車輛駕駛物理效果以及許多其他功能。車手可以使用方向盤、油門計或按鈕來控制車輛。享受這款最佳車輛駕駛模擬器和街頭賽車遊戲，它具有上癮的遊戲玩法和無盡的樂趣。現在您可以在車庫中根據您的興趣修改任何運動賽車。",
      "instructions": "使用「W,A,S,D」鍵盤按鍵進行角色移動。",
      "genres": [
        "賽車與駕駛",
        "模擬"
      ],
      "tags": [
        "城市",
        "沙漠",
        "漂移",
        "特技",
        "赛道"
      ]
    },
    "zh-HK": {
      "title": "極端真實汽車駕駛2025",
      "description": "這款終極汽車賽車3D遊戲讓你體驗真實的汽車駕駛模擬器，如高速公路賽車，具備真實的車輛損壞、精準的車輛駕駛物理學及其他多種特色。汽車駕駛員可以使用方向盤、油門計或按鈕來控制汽車。享受這款最佳汽車駕駛模擬器和街頭賽車遊戲，遊戲玩法令人上癮，充滿無盡的樂趣。現在你可以根據你的興趣，從車庫中修改任何運動賽車。",
      "instructions": "使用「W,A,S,D」鍵控制角色移動。",
      "genres": [
        "賽車及駕駛",
        "模擬"
      ],
      "tags": [
        "城市",
        "沙漠",
        "漂移",
        "特技",
        "賽道"
      ]
    },
    "ja": {
      "title": "極限リアルカーデラウィング2025",
      "description": "この究極の3Dカーレースは、リアルな車の損傷、正確な車の運転物理、多くの他の機能を持つハイウェイレースなどのリアルな車の運転シミュレーターを体験できます。カーデライバーは、ステアリング、アクセラターやボタンを使用して車を制御できます。最高の車の運転シミュレーターゲームと、中毒性のあるゲームプレイと無限の楽しみを持つドライブレースゲームをお楽しみください。今や、興味に応じてガレージからどんなスポーツレーシングカーもカスタマイズできます。",
      "instructions": "プレイヤーの移動には「W,A,S,D」を使用してください。",
      "genres": [
        "レーシング & ドライビング",
        "シミュレーション"
      ],
      "tags": [
        "都市",
        "砂漠",
        "ドライブ",
        "スタント",
        "トラック"
      ]
    },
    "ko": {
      "title": "extreme 실제 자동차 드라이빙 2025",
      "description": "이 최종적인 카라싱 3D는 실제 카드라이빙 시뮬레이터와 같은 고속도로 경주를 경험할 수 있도록 하며, 실제적인 차량 손상, 정확한 차량 운행 물리학 및 다양한 기능을 제공합니다. 카드라이버는 스티어링 휠, 가속계, 버튼을 사용하여 차량을 제어할 수 있습니다. 최고의 카드라이빙 시뮬레이터 게임과 중독성이 높은 게임 플레이와 끝없는 즐거움을 즐겨보세요. 지금부터는 자신의 취향에 맞게 가게에서 어떤 스포츠 레이싱 차량도 개조할 수 있습니다.",
      "instructions": "플레이어 이동을 위해 \"W,A,S,D\"를 사용하세요.",
      "genres": [
        "레이싱 & 드라이빙",
        "시뮬레이션"
      ],
      "tags": [
        "도시",
        "사막",
        "드래프트",
        "스탠트",
        "트랙"
      ]
    },
    "fr": {
      "title": "Conduite extrême de voitures réelles 2025",
      "description": "Ce jeu de course automobile 3D ultime vous permet de vivre une simulation de conduite de voiture réelle, avec des courses sur l'autoroute, des dommages de voiture réalistes, une physique de conduite de voiture précise et de nombreuses autres fonctionnalités. Le conducteur de voiture peut utiliser le volant, le compteur d'accélérateur ou les boutons pour contrôler la voiture. Profitez du meilleur jeu de simulation de conduite de voiture et du jeu de course en drag qui offre un gameplay accrocheur et du plaisir sans fin. Maintenant, vous pouvez modifier n'importe quelle voiture de course sportive de votre garage selon vos intérêts.",
      "instructions": "Utilisez \"W,A,S,D\" pour le déplacement du joueur.",
      "genres": [
        "Courses & Conduite",
        "Simulation"
      ],
      "tags": [
        "ville",
        "désert",
        "drift",
        "figures d'acrobaties",
        "piste"
      ]
    }
  }
};
